export default {
    list: [{
            id: 1,
            name: 'English',
            code: 'en',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/united-kingdom.png'
        },
        {
            id: 2,
            name: 'Spanish',
            code: 'es',
            img: 'https://gm.goz.fun/wp-content/uploads/2023/03/spain.png'
        }
    ]
}
